import { render, staticRenderFns } from "./FormAcreditacion.vue?vue&type=template&id=003490be"
import script from "./FormAcreditacion.vue?vue&type=script&setup=true&lang=js"
export * from "./FormAcreditacion.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports